import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-adecd18a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "text-missing"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: `/ico/support-blue.svg` }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "score-container" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (answer) => {
    return (_openBlock(), _createElementBlock("tr", {
      title: answer.getAuditorLabel(_ctx.state.stores!)
    }, [
      _createElementVNode("td", null, [
        (answer.toPDF() === '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.Lang.getI18N("answer-missing")), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.question.type === 'text_input')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: answer.text!
                  }, _toDisplayString(_ctx.truncateText(answer.text!, 120)), 9, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(answer.toPDF()), 1))
            ], 64))
      ]),
      _createElementVNode("td", null, [
        (answer.comment !== null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "comments-container",
              onClick: ($event: any) => (_ctx.showComment(answer))
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_8, [
        (_ctx.question.score)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(`${answer.score}/${_ctx.question.score}`), 1))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_1))
  }), 256))
}